import React from 'react'
import cx from 'classnames'
import { constants } from 'helpers'
import { useFt } from 'hooks'
import { Message } from 'intl'

import { Text } from 'components/dataDisplay'
import ProductImage from 'compositions/ProductImage/ProductImage'

import messages from './messages'
import s from './OrderProductBase.scss'

import defaultImageOld from './images/default.png'
import defaultImageRebrand from './images/default-rebrand.png'


type OrderProductBaseProps = {
  className?: string
  name?: string
  brand?: string
  price?: string | null
  quantity?: number
  size?: string
  priceNode?: React.ReactNode
  beforeNode?: React.ReactNode
  afterNode?: React.ReactNode
  'data-testid'?: string
} & AllOrNothing<{
  image: string
  rebrandImage: string
}>

const OrderProductBase: React.CFC<OrderProductBaseProps> = (props) => {
  const { children, className, image, rebrandImage, name, brand, price, quantity, size, priceNode, beforeNode, afterNode, 'data-testid': dataTestId } = props

  const isPhysicalRebrandCaseEnabled = useFt(constants.features.physicalRebrandCase)

  const defaultImage = isPhysicalRebrandCaseEnabled ? defaultImageRebrand : defaultImageOld

  const isFree = price === null

  const content = children || (
    <>
      {beforeNode}
      {
        Boolean(brand) && (
          <Text
            message={brand}
            style="t2"
          />
        )
      }
      {
        Boolean(name) && (
          <Text
            message={name}
            style="p3"
          />
        )
      }
      {
        Boolean(size || quantity) && (
          <Text
            style="p5"
            color="gold-70"
          >
            {
              quantity > 1 && (
                <>
                  <b>
                    <Message value={{ ...messages.quantity, values: { quantity } }} />
                  </b>
                  {
                    Boolean(size) && (
                      <span> – </span>
                    )
                  }
                </>
              )
            }
            {size}
          </Text>
        )
      }
      {afterNode}
    </>
  )

  return (
    <div className={cx(className, 'flex items-center')} data-testid={dataTestId}>
      <ProductImage
        className={cx(s.image, 'flex-none')}
        bgColor="light-beige"
        src={rebrandImage || image || defaultImage}
      />
      <div className="ml-16 flex-1 min-w-1">
        {content}
      </div>
      <div className="ml-24 flex-none">
        {priceNode}
        {
          Boolean(price || isFree) && (
            <Text
              message={isFree ? messages.free : price}
              style={isFree ? 'p2' : 't2'}
              data-testid="price"
            />
          )
        }
      </div>
    </div>
  )
}


export default OrderProductBase
